import Swiper, { Scrollbar, A11y, Mousewheel } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';

Swiper.use([ Scrollbar, A11y, Mousewheel ]);

if(document.querySelector('.posts-block')){
    document.querySelectorAll('.posts-block__posts').forEach(slider => {
        let breakpoints = {
          1024: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 2,
          }
        };
        let spv = 1.5;

        if(slider.classList.contains('alignfull')) {
            spv = 1.5;
            breakpoints = {
              1440: {
                slidesPerView: 7.2,
              },
              1024: {
                slidesPerView: 4.2,
              },
              600: {
                slidesPerView: 3,
              }
            };
        }

        new Swiper(slider, {
            allowTouchMove: true,
            slidesPerView: spv,
            spaceBetween: 15,
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            breakpoints: breakpoints,
        });
    });
}
